/* Contains the default layouts structure for each page */

import { v4 as uuidv4 } from "uuid"

const getPageDefaultLayout = (page_slug) => {
  let layout = null
  let slug = null
  let name = null

  if (page_slug == "find_leads") {
    layout = [
      {
        h: 36,
        w: 72,
        x: 0,
        y: 0,
        id: uuidv4(),
        maxH: 72,
        minH: 24,
        minW: 24,
        name: "Find Leads",
        moved: false,
        props: {
          hidden: false,
          component_type: "find_leads",
          component_props: {
            label: "Find Leads"
          }
        },
        visible: true,
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = "Find Leads"
  }

  if (page_slug == "expansion_lists") {
    layout = [
      {
        h: 36,
        w: 72,
        x: 0,
        y: 0,
        id: uuidv4(),
        maxH: 72,
        minH: 24,
        minW: 24,
        name: "Saved Lists",
        moved: false,
        props: {
          hidden: false,
          component_type: "expansion_table",
          component_reference: "prospecting>expansion_table>0",
          component_props: {
            label: "Saved Lists"
          }
        },
        visible: true,
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = "Saved Lists"
  }

  if (page_slug == "suggested_list") {
    layout = [
      {
        h: 36,
        w: 72,
        x: 0,
        y: 0,
        id: uuidv4(),
        maxH: 72,
        minH: 36,
        minW: 72,
        name: "Suggested List",
        moved: false,
        is_static: true,
        fixed: true,
        props: {
          hidden: false,
          component_type: "suggested_list",
          component_props: {
            label: "Suggested List"
          },
          component_reference: "prospecting>suggested>0"
        },
        visible: true,
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = "Suggested List"
  }

  if (page_slug == "growth_matrix") {
    layout = [
      {
        h: 36,
        w: 72,
        x: 0,
        y: 0,
        id: uuidv4(),
        maxH: 72,
        minH: 36,
        minW: 72,
        name: "Growth Matrix",
        moved: false,
        is_static: true,
        fixed: true,
        props: {
          hidden: false,
          component_type: "growth_matrix",
          component_props: {
            label: "Growth Matrix"
          },
          component_reference: "prospecting>growth_matrix>0"
        },
        visible: true,
        preserveAspectRatio: false
      }
    ]

    slug = page_slug
    name = "Growth Matrix"
  }

  return [layout, name, slug]
}

export default getPageDefaultLayout
